/**
 * @flow
 * @relayHash caf9865b35833e8a48adc37a5570740f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MapRoomEmbedRootCardQueryVariables = {|
  input: string
|};
export type MapRoomEmbedRootCardQueryResponse = {|
  +boardCardUse: ?{|
    +subComponentType: ?string,
    +configuration: {|
      +title: ?string,
      +savedArea: ?{|
        +id: string,
        +name: string,
      |},
      +mapZoom: ?number,
      +mapCenterLng: ?number,
      +mapCenterLat: ?number,
      +mapLayers: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +indicator: ?{|
              +id: string,
              +indicatorName: string,
              +geographicUnit: {|
                +name: string,
                +summaryLevelCode: string,
              |},
            |},
            +alpha: ?number,
            +palette: ?number,
            +position: ?number,
            +isVisible: boolean,
          |}
        |}>
      |},
    |},
  |},
  +currentUser: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +jsonid: ?string,
        +username: ?string,
        +userFirstName: string,
        +userReportName: string,
        +userImage: ?{|
          +url: ?string
        |},
      |}
    |}>
  |},
|};
export type MapRoomEmbedRootCardQuery = {|
  variables: MapRoomEmbedRootCardQueryVariables,
  response: MapRoomEmbedRootCardQueryResponse,
|};
*/


/*
query MapRoomEmbedRootCardQuery(
  $input: ID!
) {
  boardCardUse(id: $input) {
    subComponentType
    configuration {
      title
      savedArea {
        id
        name
      }
      mapZoom
      mapCenterLng
      mapCenterLat
      mapLayers {
        edges {
          node {
            indicator {
              id
              indicatorName
              geographicUnit {
                name
                summaryLevelCode
                id
              }
            }
            alpha
            palette
            position
            isVisible
            id
          }
        }
      }
      id
    }
    id
  }
  currentUser {
    edges {
      node {
        jsonid
        username
        userFirstName
        userReportName
        userImage {
          url
          id
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "input",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subComponentType",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "savedArea",
  "storageKey": null,
  "args": null,
  "concreteType": "SavedAreaNode",
  "plural": false,
  "selections": [
    v4,
    v5
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mapZoom",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mapCenterLng",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mapCenterLat",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "indicatorName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "summaryLevelCode",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alpha",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "palette",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVisible",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jsonid",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userFirstName",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userReportName",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "MapRoomEmbedRootCardQuery",
  "id": null,
  "text": "query MapRoomEmbedRootCardQuery(\n  $input: ID!\n) {\n  boardCardUse(id: $input) {\n    subComponentType\n    configuration {\n      title\n      savedArea {\n        id\n        name\n      }\n      mapZoom\n      mapCenterLng\n      mapCenterLat\n      mapLayers {\n        edges {\n          node {\n            indicator {\n              id\n              indicatorName\n              geographicUnit {\n                name\n                summaryLevelCode\n                id\n              }\n            }\n            alpha\n            palette\n            position\n            isVisible\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  currentUser {\n    edges {\n      node {\n        jsonid\n        username\n        userFirstName\n        userReportName\n        userImage {\n          url\n          id\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MapRoomEmbedRootCardQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "boardCardUse",
        "storageKey": null,
        "args": v1,
        "concreteType": "BoardCardUseNode",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "configuration",
            "storageKey": null,
            "args": null,
            "concreteType": "BoardCardConfigurationNode",
            "plural": false,
            "selections": [
              v3,
              v6,
              v7,
              v8,
              v9,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mapLayers",
                "storageKey": null,
                "args": null,
                "concreteType": "BoardCardSelectedIndicatorNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BoardCardSelectedIndicatorNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BoardCardSelectedIndicatorNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "indicator",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SearchableIndicatorNode",
                            "plural": false,
                            "selections": [
                              v4,
                              v10,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "geographicUnit",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "GeographicUnitNode",
                                "plural": false,
                                "selections": [
                                  v5,
                                  v11
                                ]
                              }
                            ]
                          },
                          v12,
                          v13,
                          v14,
                          v15
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentUser",
        "storageKey": null,
        "args": null,
        "concreteType": "UserAccountNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserAccountNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserAccountNode",
                "plural": false,
                "selections": [
                  v16,
                  v17,
                  v18,
                  v19,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userImage",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileImageNode",
                    "plural": false,
                    "selections": [
                      v20
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MapRoomEmbedRootCardQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "boardCardUse",
        "storageKey": null,
        "args": v1,
        "concreteType": "BoardCardUseNode",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "configuration",
            "storageKey": null,
            "args": null,
            "concreteType": "BoardCardConfigurationNode",
            "plural": false,
            "selections": [
              v3,
              v6,
              v7,
              v8,
              v9,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mapLayers",
                "storageKey": null,
                "args": null,
                "concreteType": "BoardCardSelectedIndicatorNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BoardCardSelectedIndicatorNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BoardCardSelectedIndicatorNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "indicator",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SearchableIndicatorNode",
                            "plural": false,
                            "selections": [
                              v4,
                              v10,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "geographicUnit",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "GeographicUnitNode",
                                "plural": false,
                                "selections": [
                                  v5,
                                  v11,
                                  v4
                                ]
                              }
                            ]
                          },
                          v12,
                          v13,
                          v14,
                          v15,
                          v4
                        ]
                      }
                    ]
                  }
                ]
              },
              v4
            ]
          },
          v4
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentUser",
        "storageKey": null,
        "args": null,
        "concreteType": "UserAccountNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserAccountNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserAccountNode",
                "plural": false,
                "selections": [
                  v16,
                  v17,
                  v18,
                  v19,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userImage",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileImageNode",
                    "plural": false,
                    "selections": [
                      v20,
                      v4
                    ]
                  },
                  v4
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7284d4bf44ec2bbc71b5199a06490b3d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/Root/__generated__/MapRoomEmbedRootCardQuery.graphql.js